import * as angular from 'angular';
import {IController} from "angular";
import {ServiceGroupsType} from "../../types/service-groups.type";

export class DeliveriesGroupSelectCtrl implements IController {
  group: any;
  ngPlaceholder: any;
  onChange: Function;

  private options: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.options = angular.copy(Object.values(ServiceGroupsType));
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesGroupSelect', {
    bindings: {
      group: '<',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./deliveries-group-select.html').default,
    controller: DeliveriesGroupSelectCtrl
  });
